import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';
import { AreasResolver } from '../shared/resolvers';
import { MapComponent } from './map/map.component';
import { AreaService } from '../shared/services';
import { HttpModule } from '@angular/http';

const appRoutes: Routes = [
  {
    path: '', component: MapComponent, resolve: {
      areas: AreasResolver
    }
  }
]

@NgModule({
  declarations: [
    AppComponent,
    MapComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    RouterModule.forRoot(appRoutes),
  ],
  providers: [
    AreasResolver,
    AreaService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /app/src/app/app.module.ts